import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from 'src/routes/PrivateRoute';
import { SettingsPage } from '../pages';

export const routes = (
  <Route
    path="/settings/:tab?"
    element={
      <PrivateRoute>
        <SettingsPage />
      </PrivateRoute>
    }
  />
);
